import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTenantContext } from '../contexts';
import UserTable from '../features/table/UserTable';
// import VerificationTable from '../features/table/VerificationTable';
import { useVerificationService } from '../services';
/**
 * AdminPage component protected by AdminAuthGuard
 * Displays basic admin interface
 *
 * @return {JSX.Element}
 */
const AdminPage: React.FC = () => {
  const tenantContext = useTenantContext();
  const verificationService = useVerificationService();

  const handleSendVerificationRequest = async (email: string, verificationId: string) => {
    try {
      await verificationService.sendVerificationRequest(verificationId, email);
    } catch (error) {
      console.error('Error sending verification request:', error);
    }
  };
  const handleSendGroupVerificationRequest = async (
    connectionIds: string[],
    verificationId: string
  ) => {
    try {
      await verificationService.sendGroupVerificationRequest(verificationId, connectionIds);
    } catch (error) {
      console.error('Error sending group verification request:', error);
    }
  };

  // const handleCreateVerificationRequest = async (
  //   verificationId: string,
  //   comment: string,
  //   autoVerify: boolean,
  //   autoRemove: boolean
  // ) => {
  //   try {
  //     await verificationService.createVerificationRequest(
  //       verificationId,
  //       comment,
  //       autoVerify,
  //       autoRemove
  //     );
  //   } catch (error) {
  //     console.error('Error creating verification request:', error);
  //   }
  // };

  return (
    <View style={styles.container}>
      <Text style={styles.header}>Admin Dashboard</Text>
      <View style={styles.tablesContainer}>
        <View style={styles.tableSection}>
          <UserTable
            users={tenantContext.users || []}
            verifications={tenantContext.verifications || []}
            onSendVerificationRequest={handleSendVerificationRequest}
            isLoading={tenantContext.isLoading || tenantContext.isRefreshing}
            onSendGroupVerificationRequest={handleSendGroupVerificationRequest}
          />
        </View>

        {/* <View style={styles.tableSection}>
          <VerificationTable
            verifications={tenantContext.verifications || []}
            verificationRequests={tenantContext.verificationRequests || []}
            onCreateVerificationRequest={handleCreateVerificationRequest}
            isLoading={tenantContext.isLoading || tenantContext.isRefreshing}
          />
        </View> */}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    maxWidth: 1600,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%'
  },
  header: {
    fontSize: 24,
    fontWeight: '700',
    color: '#000000',
    marginBottom: 16
  },
  contentSection: {
    backgroundColor: '#ffffff',
    padding: 16,
    borderRadius: 8,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    marginBottom: 16
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#30394C',
    marginBottom: 8
  },
  description: {
    fontSize: 14,
    color: '#6B7280',
    lineHeight: 20
  },
  tablesContainer: {
    flex: 1,
    flexDirection: 'row',
    gap: 16,
    minHeight: 600
  },
  tableSection: {
    backgroundColor: '#ffffff',
    borderRadius: 8,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    flex: 1,
    overflow: 'hidden'
  }
});

export default AdminPage;
